import { Expansion } from "@/lib/types/common/Expansion";

// Wallpaper configuration per expansion
export const EXPANSION_WALLPAPERS: Record<string, number> = {
    [Expansion.ARR.toLowerCase()]: 4,
    [Expansion.HW.toLowerCase()]: 3,
    [Expansion.SB.toLowerCase()]: 5,
    [Expansion.ShB.toLowerCase()]: 8,
    [Expansion.EW.toLowerCase()]: 8,
    [Expansion.DT.toLowerCase()]: 9,
};

// Simple seeded random function
function seededRandom(seed: string): number {
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
        const char = seed.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    // Convert to positive number between 0 and 1
    return Math.abs(Math.sin(hash)) % 1;
}

/**
 * Get a random wallpaper path based on selected expansions, game seed, and current round
 * @param selectedExpansions - Array of selected expansion names
 * @param gameSeed - Seed for consistent randomization
 * @param currentRound - Current round number for different wallpapers each round
 * @returns Path to the wallpaper image
 */
export function getRandomWallpaper(selectedExpansions: string[], gameSeed: string, currentRound: number): string {
    // Build list of all available wallpapers from selected expansions
    const availableWallpapers: string[] = [];

    for (const expansion of selectedExpansions) {
        const expLower = expansion.toLowerCase();
        const count = EXPANSION_WALLPAPERS[expLower];
        if (count) {
            for (let i = 1; i <= count; i++) {
                availableWallpapers.push(`/loading/${expLower}/${i}.webp`);
            }
        }
    }

    // Fallback to ARR if no wallpapers found
    if (availableWallpapers.length === 0) {
        return "/loading/arr/1.webp";
    }

    // Use seeded random with round number to pick a different wallpaper each round
    const randomValue = seededRandom(`${gameSeed}-round-${currentRound}`);
    const index = Math.floor(randomValue * availableWallpapers.length);

    return availableWallpapers[index];
}
